import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
import { environment } from '../../../../environments/environment';
const HEADERS = {};

@Injectable()
export class BalanceThirdService {
  static ENV = environment;

  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
  }

  public createTrxBalance(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(BalanceThirdService.ENV.environment.API.create_trx_balance, data, httpRequesthandler);
  }

  public alert_create_balance(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(BalanceThirdService.ENV.environment.API.alert_create_balance, data, httpRequesthandler);
  }

  public getProcessId(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(BalanceThirdService.ENV.environment.API.f_get_process_id, httpRequesthandler);
  }
  public TableSummaryBal(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(BalanceThirdService.ENV.environment.API.f_table_summary_bal, data, httpRequesthandler);
  }

  public cancelTask(data: any, process_id : number, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    let resource = `${BalanceThirdService.ENV.environment.API.cancel_task_balance}/${process_id}`;
    this.httpService.post(resource, data, httpRequesthandler);
  }

  public balance_third_ica(data, httpRequesthandler : HttpRequestHandler){
    httpRequesthandler.headers = HEADERS; 
    let url = BalanceThirdService.ENV.environment.API.balance_third_ica;

    this.httpService.post(url, data, httpRequesthandler);
  }

  public balance_third_iva(data, httpRequesthandler : HttpRequestHandler){
    httpRequesthandler.headers = HEADERS; 
    let url = BalanceThirdService.ENV.environment.API.balance_third_iva;

    this.httpService.post(url, data, httpRequesthandler);
  }

  public balance_third_rtica(data, httpRequesthandler : HttpRequestHandler){
    httpRequesthandler.headers = HEADERS; 
    let url = BalanceThirdService.ENV.environment.API.balance_third_rtica;

    this.httpService.post(url, data, httpRequesthandler);
  }

  public balance_third_rtfuente(data, httpRequesthandler : HttpRequestHandler){
    httpRequesthandler.headers = HEADERS; 
    let url = BalanceThirdService.ENV.environment.API.balance_third_rtf;

    this.httpService.post(url, data, httpRequesthandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/third-party/balance-third.service.ts